import { $fetch } from '@/services/axios';
import { sortBy } from 'lodash-es';

export function fetch() {
  return $fetch(`system/applications`).then(rows => {
    return sortBy(rows, ['appId']);
  });
}
